<template>
    <v-card :loading="loading" width="450">
        <v-card-title class="d-flex w-100 justify-space-between text-wrap">
            <p>{{ "Delete " + typeToDelete }}</p>
            <v-btn density="compact" class="align-self-start" icon="mdi-close" variant="text" color="primary"
                @click="$emit('close')"></v-btn>

        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
            {{ text }}
        </v-card-text>
        <v-card-actions>
            <v-btn @click="confirm()" class="w-100" color="red" variant="elevated" text="Delete"></v-btn>
        </v-card-actions>
    </v-card>
</template>


<script setup>
import { ref } from 'vue';

const loading = ref(false);
const emit = defineEmits(['close', 'confirm']);

const props = defineProps({
    text: String,
    typeToDelete: String,
})

const confirm = () => {
    loading.value = true;
    emit('confirm');
}


</script>